export { TagsInputComponent } from './tags-input.component';
export { L_TagsInputModule } from './tags-input.module';



// WEBPACK FOOTER //
// ./.tmp/tags-input/index.ts